import { render, staticRenderFns } from "./CommentCellBtn.vue?vue&type=template&id=52aa7d68&"
import script from "./CommentCellBtn.vue?vue&type=script&lang=ts&"
export * from "./CommentCellBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports